import { Bell } from "lucide-react";
import { Link } from "react-router";

import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { PROTECTED_ROUTES } from "@/constants/routes";
import { useUnreadNotificationCount } from "@/features/engagement/hooks/useUnreadNotificationCount";

/** docs/architecture/claude/ui-architecture.md's "Full app header ...
 * notification bell" — an icon button with an unread-count badge, linking
 * to `/notifications`. */
export function NotificationBell() {
  const unreadCountQuery = useUnreadNotificationCount();
  const count = unreadCountQuery.data?.count ?? 0;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button type="button" variant="ghost" size="icon" aria-label="Notifications" asChild>
          <Link to={PROTECTED_ROUTES.notifications} className="relative">
            <Bell className="h-4 w-4" aria-hidden="true" />
            {count > 0 && (
              <span className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 text-[10px] font-medium text-primary-foreground">
                {count > 9 ? "9+" : count}
              </span>
            )}
          </Link>
        </Button>
      </TooltipTrigger>
      <TooltipContent>Notifications</TooltipContent>
    </Tooltip>
  );
}
